import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  IThemeConfig,
  useTheme,
  getConfig,
  PageDataContainer
} from "../../../../_start/layout/core";
import { StartDashboardPage } from "./StartDashboardPage";
import store from "../../../../setup/redux/Store";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../config/firebase";


const defaultPageConfig = getConfig();
const dashboardPageConfig: Partial<IThemeConfig> = {
  toolbar: {
    ...defaultPageConfig.toolbar,
    display: true,
  },
  aside: {
    ...defaultPageConfig.aside,
    display: true,
    primaryDisplay:  true,
    secondaryDisplay: false,
    toggle: true,
    content: "menu",
  }
};

const fetchUser = async () => {
  const userID = store.getState().auth?.user?.uid || null;
  return userID;
};

export function StartDashboardWrapper() {
  const { setTheme } = useTheme();
  const [userID, setUserID] = useState<string | null>(null);
  const [impersonateUID, setImpersonateUID] = useState<string | undefined>(undefined);
  const [impersonateEmail, setImpersonateEmail] = useState<string | undefined>(undefined);

  const [searchParams] = useSearchParams();
  const uidParam = searchParams.get("uid");

  useEffect(() => {
    const init = async () => {
      const currentUID = await fetchUser();
      setUserID(currentUID);

      // Impersonation: only if uid param present and current user is admin
      if (uidParam && currentUID) {
        try {
          const currentUserSnap = await getDoc(doc(db, "users", currentUID));
          if (currentUserSnap.exists() && currentUserSnap.data().isAdmin === true) {
            setImpersonateUID(uidParam);
            // Fetch target user's email for banner display
            try {
              const targetSnap = await getDoc(doc(db, "users", uidParam));
              if (targetSnap.exists()) {
                const data = targetSnap.data();
                setImpersonateEmail(
                  (data.email as string | undefined) ??
                  (data.displayName as string | undefined) ??
                  uidParam.slice(0, 12) + "…"
                );
              } else {
                setImpersonateEmail(uidParam.slice(0, 12) + "…");
              }
            } catch {
              setImpersonateEmail(uidParam.slice(0, 12) + "…");
            }
          }
        } catch {
          // Non-critical — impersonation fails silently, falls back to normal view
        }
      }
    };

    init();
    setTheme(dashboardPageConfig);

    return () => {
      setTheme(defaultPageConfig);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PageDataContainer />
      {userID && (
        <StartDashboardPage
          userID={userID}
          impersonateUID={impersonateUID}
          impersonateEmail={impersonateEmail}
        />
      )}
    </>
  );
}
